/*@ngInject*/
module.exports = function() {
    return {
        scope: {
            object: '=',
        },
        bindToController: true,
        controllerAs: 'vm',
        /*@ngInject*/
        controller: function($scope, mapService, $sce, $rootScope) {
            let vm = this;
            vm.url = '';
            vm.mapUrlsLoaded = false;
            vm.rootscope = $rootScope;

            vm.$onInit = function() {
                const mapUrls = vm.rootscope.mapUrls;
                let hideUrls = mapUrls.roadElementPathUrl + ',' + mapUrls.roadElementObstacleUrl + ',' + mapUrls.routeUrl;

                vm.url = $sce.trustAsResourceUrl(mapUrls.mapUrl + '?init=[{"type":"filter","ids":[' + JSON.stringify(vm.object.gis_id) +'],"url":' + JSON.stringify(mapUrls.objectUrl) + ',"zoomTo":true},{"type":"filter","ids":[' + JSON.stringify(vm.object.gis_id) +'],"url":' + JSON.stringify(mapUrls.busStopUrl) + ',"zoomTo":true},{"type":"hide-layers","url":' + JSON.stringify(hideUrls) + '}]');
                vm.mapUrlsLoaded = true;
            };
        },
        template: require('./object-mapview.directive.html')
    };
};



/** WEBPACK FOOTER **
 ** ./app/shared/directives/object-mapview.directive.js
 **/